module.exports = __webpack_public_path__ + "static/img/jgcx-bg.dc627bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/appCenter/img/jgcx-bg.png
// module id = hJJb
// module chunks = 96